export default __webpack_public_path__ + "static/media/009-flash disk.fbdd31d3.svg";